// The bilingual marking text of the classification banner (DESIGN-SYSTEM §10.1): the level's mark in capitals with its Arabic name, and
// the handling line of the Ministry's data-classification policy. They are fixed policy identity shown in both languages at once (like
// the policy names of SENSITIVITY_NAMES), not interface copy, so they live here rather than in a locale file. Pending MoET's exact policy
// wording (DESIGN-SYSTEM §20.2). WP-SHELL.
import type { Sensitivity } from "@ncp/assistant-sdk/contracts";

export const MARK_EN: Readonly<Record<Sensitivity, string>> = { public: "PUBLIC", internal: "INTERNAL", restricted: "RESTRICTED", confidential: "CONFIDENTIAL" };

export const POLICY_LINE = {
  en: "Handle under the MoET data-classification policy",
  ar: "يتداول وفق سياسة الوزارة لتصنيف البيانات",
} as const;
